import { EndUser } from '../types/end-user'
import { graphQLClient } from './authService'
import endUserMutations from './graphql/appUsers/mutations'

class EndUsersService {
  updateNumberNbPoints = async ({ id, nbPoints }: Pick<EndUser, 'id' | 'nbPoints'>) => {
    const { updateEndUser: response } = await graphQLClient.request<{
      updateEndUser: EndUser
    }>(endUserMutations.updateEndUser, {
      where: {
        id,
      },
      data: {
        nbPoints,
      },
    })

    return response
  }

  suspendEndUser = async ({ id, isSuspended }: Pick<EndUser, 'id' | 'isSuspended'>) => {
    const { updateEndUser: response } = await graphQLClient.request<{
      updateEndUser: EndUser
    }>(endUserMutations.updateEndUser, {
      where: {
        id,
      },
      data: {
        isSuspended,
      },
    })

    return response
  }
}

const endUsersService = new EndUsersService()

export default endUsersService
